var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(!_vm.$store.state.is_loading)?_c('Footer'):_vm._e(),_c('Search'),(_vm.show_cookies)?_c('Cookies'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }